import { Query } from 'redux-little-router';
import { createSelector } from 'reselect';

import { SortDirection, SortParams } from '../typings/grid';
import { State } from '../typings/state';

const PRODUCTS_DEFAULT_SORT_DIRECTION = SortDirection.desc;

export const selectProductsSortParams = createSelector(
    (state: State) => state.router.query,
    (query?: Query): SortParams | undefined => {
        if (query && query.key) {
            return {
                key: query.key,
                direction:
                    SortDirection[query.direction] ||
                    PRODUCTS_DEFAULT_SORT_DIRECTION
            };
        }
        return undefined;
    }
);
